import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=ab173128&scoped=true&"
import script from "./ImageView.vue?vue&type=script&lang=ts&"
export * from "./ImageView.vue?vue&type=script&lang=ts&"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=ab173128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab173128",
  null
  
)

export default component.exports